import { useRef, useState } from "react";
import { UploadCloud } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export const SapUpload = ({ onPreview, path = "/sap/preview", hint = "Drag & drop the SAP export here, or click to choose", testId = "sap" }) => {
  const [drag, setDrag] = useState(false);
  const [busy, setBusy] = useState(false);
  const input = useRef(null);
  const send = async (file) => {
    if (!file) return;
    setBusy(true);
    const fd = new FormData();
    fd.append("file", file);
    try {
      onPreview((await api.post(path, fd)).data);
    } catch (e) {
      toast.error(errMsg(e));
    }
    setBusy(false);
  };
  return (
    <div
      data-testid={`${testId}-dropzone`}
      onDragOver={(e) => { e.preventDefault(); setDrag(true); }}
      onDragLeave={() => setDrag(false)}
      onDrop={(e) => { e.preventDefault(); setDrag(false); send(e.dataTransfer.files[0]); }}
      onClick={() => input.current?.click()}
      className={`flex cursor-pointer flex-col items-center justify-center gap-2 rounded-sm border-2 border-dashed px-6 py-10 text-center transition-colors ${drag ? "border-[#e4002b] bg-[#e4002b]/10" : "border-slate-700 hover:border-slate-500"}`}
    >
      <UploadCloud className="h-8 w-8 text-slate-400" />
      <div className="text-sm text-slate-200">{busy ? "Reading file…" : hint}</div>
      <div className="text-xs text-slate-500">CSV (comma, semicolon or tab) or Excel .xlsx — one row per sales order item</div>
      <input ref={input} type="file" accept=".csv,.txt,.xlsx,.xls" className="hidden" data-testid={`${testId}-file-input`} onChange={(e) => { send(e.target.files[0]); e.target.value = ""; }} />
    </div>
  );
};
